$(function () {
    const enable = (object, cookie) => {
        Cookies.set(cookie, true);
        object
            .closest('.perfmon-toggle')
            .addClass('enabled')
            .removeClass('disabled');
        console.log(`${cookie} enabled`);
    }

    const disable = (object, cookie) => {
        Cookies.set(cookie, false);
        object
            .closest('.perfmon-toggle')
            .addClass('disabled')
            .removeClass('enabled');
        console.log(`${cookie} disabled`);
    }

    const init = (object, cookie) => {
        object.on('click', click(cookie));
        if (Cookies.get(cookie) === 'true') {
            enable(object, cookie);
        } else {
            disable(object, cookie);
        }
    }

    const click = (cookie) => {
        return function () {
            if (Cookies.get(cookie) === 'true') {
                disable($(this), cookie);
            } else {
                enable($(this), cookie);
            }
        }
    }

    init($('#dev-info--performance-monitor--query-data'), 'perfmon-query-data');
    init($('#dev-info--performance-monitor--sql-no-cache'), 'perfmon-sql-no-cache');
});
